import React, { useEffect, useState } from 'react';
import "aos/dist/aos.css";
import AOS from "aos";
import { Container, Row, Col, Card, ListGroup, Badge } from 'react-bootstrap';
import servicebanner from '../Assets/Image/namkeenContractorService.jpg';
import '../Assets/WebsiteCss/services.css';
import { FaLightbulb, FaProjectDiagram, FaBoxOpen, FaCogs, FaFlask, FaShapes, FaCheckCircle, FaUsers, FaPlay, FaClipboardList, FaBroom, FaArrowRight } from 'react-icons/fa';

import { FaUserTie, FaHardHat, FaTools } from 'react-icons/fa';
import { GiCookingPot } from 'react-icons/gi';
import { MdPrecisionManufacturing } from 'react-icons/md';
import { BiGroup } from 'react-icons/bi';
import { Helmet } from "react-helmet";

import {
  FaBoxes,
  FaUtensils,
  FaUsersCog,
  FaIndustry,
  FaThumbsUp,
  FaClipboardCheck,
} from 'react-icons/fa';


// const rawData = `


// Idea-Project finalization Report
// Understanding Idea & Concept of person. As per their demand & Market Requirments.

// Area Layout for Production and Storage.
// After the project idea finalization. We will planning area layout for production to packaging and storage.

// Products Selecting Process
// We will help you out to select the running products in their market & local areas.

// Processing machinery selection
// We will suggest you the right machine in your budget to get production efficiently on regular basis.

// Machinery installation
// To setup machinery line in order to maintain the work & supply line flow regularly.

// Determination of initial production
// As the machinery installation our experts will start pilot project for making the recipe.

// Demonstrate 3-4 various manner of each product.
// After the initial production starts, we will demonstrate 3-4 various recipes & taste of each products.

// Product finalization work
// We will help you out to select best recipe from which we demonstrated.

// Determination of Production Team & Quality Experts.
// After product finalization we select the best team of skilled persons to assign further processes.

// Start final Production
// After complete all the process, Our trained and experienced karigars and helpers will start the final production.

// Get Work Done
// We will take feedback from you after the final production of recipe & team work.

// Reporting- Weekly Cleaning / Maintenance Programme
// We will continuously reporting on weekly basis about cleaning & maintenances program.
// `;




export default function Services() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const [activeModule, setActiveModule] = useState(0);


  const serviceFeatures = [
    {
      title: "Supervisor",
      icon: <FaUserTie size={40} color="#DC4321" />,
      description:
        "Skilled professionals with experience in managing namkeen production units, ensuring smooth operations, labor management, and production timelines.",
    },
    {
      title: "Namkeen Karigars / Operators",
      icon: <GiCookingPot size={40} color="#DC4321" />,
      description:
        "Expert Karigars trained in preparing authentic Rajasthani namkeen with precise techniques to maintain taste, texture, and tradition.",
    },
    {
      title: "Packaging Machine Operators",
      icon: <MdPrecisionManufacturing size={40} color="#DC4321" />,
      description:
        "Trained workers who operate, monitor, and maintain automatic/semi-automatic namkeen packaging machines efficiently.",
    },
    {
      title: "Semi-Skilled Karigars",
      icon: <FaHardHat size={40} color="#DC4321" />,
      description:
        "Support staff who assist in frying, seasoning, mixing, and moving products as per supervisor's instructions.",
    },
    {
      title: "Other Staff as Per Your Requirement",
      icon: <BiGroup size={40} color="#DC4321" />,
      description:
        "We offer loaders, cleaners, helpers, and other labor as per your specific needs.",
    },
    {
      title: "Maintenance & Utility Workers",
      icon: <FaTools size={40} color="#DC4321" />,
      description:
        "Dedicated staff for machinery upkeep, utility management, and ensuring a clean and efficient production environment throughout the unit.",
    }
  ];

  const modules = [
    {
      title: 'Training Programme for Production Team',
      description: `
        First of all, first module is like we provide a training programme to all your Production team 
        so that we can help the people to improve the taste in the namkeen & snacks. What is the need 
        of customers and also we can develop a new taste which is highly efficient. We also provide 
        a quality manager in order to provide the supervision for your ongoing processes.
      `
    },
    {
      title: 'New Business & Product Development',
      description: `
        Second, for a new business we can arrange a couple of weeks programme to new products development 
        and recipe or trained your team in a manner, so that you start your namkeen & snacks business in 
        healthy way. This learning must implement in every start-ups and it helping you out to enlarge 
        your own business.
      `
    },
    {
      title: 'Labour Contract & Production Support',
      description: `
        Third module what comes as the production module we provide the labour contract on the contract basis 
        so that they can go ahead for the daily production and there is a per kilogram rate for it that you how 
        to pay us for the costing production so we can also help you out in that manner and also if some of your 
        area man power supply have a gone for holidays and you are lacking some of the labour so we provide a 
        substitute for that purpose to carry on the work which helps in maintaining the consistency as well.
      `
    }
  ];

  const extraContent = `
    We are very happy to know that your company deals in many products and services and you will get a lot of pleasure 
    as a consultant by getting you snacks and namkeen work done in this sequence, and you will also feel a work friendly 
    with Namkeen Contractor.

    Knowing many things before a new start of any work makes our way to reach success, that’s why our company works 
    with all our customers from the beginning of the work to the smooth running of the work in which includes the following tasks.
  `;

  const steps = [
    { icon: <FaLightbulb />, title: 'Idea' },
    { icon: <FaProjectDiagram />, title: 'Project Finalisation' },
    { icon: <FaBoxOpen />, title: 'Product Selection' },
    { icon: <FaCogs />, title: 'Machinery Selection' },
    { icon: <FaTools />, title: 'Installation' },
    { icon: <FaFlask />, title: 'Initial Production' },
    { icon: <FaShapes />, title: 'Product Variants Demo' },
    { icon: <FaCheckCircle />, title: 'Finalisation' },
    { icon: <FaUsers />, title: 'Team Setup' },
    { icon: <FaPlay />, title: 'Production Start' },
    { icon: <FaClipboardList />, title: 'Reporting' },
    { icon: <FaBroom />, title: 'Cleaning & Maintenance' },
  ];

  
  const services = [
    {
      icon: <FaLightbulb className=" text-warning" />,
      title: 'Idea-Project finalization Report',
      description: 'Understanding Idea & Concept of person. As per their demand & Market Requirments.',
    },
    {
      icon: <FaProjectDiagram className=" text-primary" />,
      title: 'Area Layout for Production and Storage.',
      description: 'After the project idea finalization. We will planning area layout for production to packaging and storage.',
    },
    {
      icon: <FaBoxes className=" text-success" />,
      title: 'Products Selecting Process',
      description: 'We will help you out to select the running products in their market & local areas.',
    },
    {
      icon: <FaCogs className=" text-danger" />,
      title: 'Processing machinery selection',
      description: 'We will suggest you the right machine in your budget to get production efficiently on regular basis.',
    },
    {
      icon: <FaTools className=" text-secondary" />,
      title: 'Machinery installation',
      description: 'To setup machinery line in order to maintain the work & supply line flow regularly.',
    },
    {
      icon: <FaFlask className=" text-info" />,
      title: 'Determination of initial production',
      description: 'As the machinery installation our experts will start pilot project for making the recipe.',
    },
    {
      icon: <FaUtensils className=" text-success" />,
      title: 'Demonstrate 3-4 various manner of each product.',
      description: 'After the initial production starts, we will demonstrate 3-4 various recipes & taste of each products.',
    },
    {
      icon: <FaCheckCircle className=" text-success" />,
      title: 'Product finalization work',
      description: 'We will help you out to select best recipe from which we demonstrated.',
    },
    {
      icon: <FaUsersCog className="text-warning" />,
      title: 'Determination of Production Team & Quality Experts.',
      description: 'After product finalization we select the best team of skilled persons to assign further processes.',
    },
    {
      icon: <FaIndustry className=" text-primary" />,
      title: 'Start final Production',
      description: 'After complete all the process, Our trained and experienced karigars and helpers will start the final production.',
    },
    {
      icon: <FaThumbsUp className=" text-info" />,
      title: 'Get Work Done',
      description: 'We will take feedback from you after the final production of recipe & team work.',
    },
    {
      icon: <FaClipboardCheck className=" text-dark" />,
      title: 'Reporting- Weekly Cleaning / Maintenance Programme',
      description: 'We will continuously reporting on weekly basis about cleaning & maintenances program.',
    },
  ];



  const serviceRows = [];
  for (let i = 0; i < services.length; i += 2) {
    serviceRows.push(services.slice(i, i + 2));
  }


  return (

    <div className="mainnav min-vh-100">
     
  
  <Helmet>
    <title>Our Services | Narayan Salvi Namkeen Contractor – Labour Solutions & Production Setup</title>

    <meta
      name="description"
      content="Explore Narayan Salvi’s expert labour contracting services for namkeen manufacturing. From supervisors, skilled karigars, to machinery selection and plant setup – we guide you from idea to final production."
    />

    <meta
      name="keywords"
      content="Namkeen Labour Contractor, Namkeen Plant Setup, Namkeen Machine Operator, Namkeen Production Training, Snacks Business Consultant, Namkeen Packaging Labour, Namkeen Karigars, Start Namkeen Business, Production Support"
    />

    <meta name="author" content="Narayan Salvi Group" />

    {/* Open Graph for social media preview */}
    <meta property="og:title" content="Our Services | Narayan Salvi Namkeen Contractor" />
    <meta
      property="og:description"
      content="End-to-end namkeen manufacturing support – supervisors, karigars, packaging experts, and plant setup guidance across India."
    />
    <meta property="og:type" content="website" />
    <meta property="og:url" content="https://nsnamkeenlabourcontractor.com/services" />
    <meta property="og:image" content="https://nsnamkeenlabourcontractor.com/static/media/namkeenContractorService.b6bc09f3458e29fe00d7.jpg" />

    {/* Responsive design support */}
    <meta name="viewport" content="width=device-width, initial-scale=1" />

    {/* Favicon */}
    <link rel="icon" href="/favicon.ico" />
  </Helmet>
      {/* Banner */}
       <div className="service-container">
        <img src={servicebanner} alt="" className="servicenamkken img-fluid" />
        <div className="service-text">"Expert Labour Contracts for Seamless Namkeen Manufacturing"</div>
      </div>

      <Container className="my-3">
        {/* Our Services */}
        <section className="" style={{ backgroundColor: "#f8f9fa" }}>
          <Container>
            <Row className="text-center mb-4">
              <Col>
                <h2
                  className="middletext mb-3" data-aos="zoom-in"
                >
                  Our Services
                </h2>
                <p className="lead text-muted">
                  We provide <b>end-to-end labour contracting</b> from{" "}
                  <b>manufacturing to final packing</b>, utilizing{" "}
                  <b>automatic & hand machinery</b> for the best efficiency.
                  <br />

                </p>
                <b>We Provide Services : </b>
              </Col>
            </Row>

    
                <Row>
                  {serviceFeatures.map((service, idx) => (
                    <Col md={4} xs={12} key={idx} className='mb-3'>
                      <Card className="provideservice   h-100">
                        <Card.Body className="text-center">
                          {service.icon}
                          <h5 className="mt-3">{service.title}</h5>
                          <p className="text-muted">{service.description}</p>
                        </Card.Body>
                      </Card>
                    </Col>
                  ))}
                </Row>
              
          </Container>
        </section>

        {/* Stage of Process */}
        <section className="mb-5 mt-3">
          <Container>
            <h2 className="middletext mb-2 text-center" data-aos="zoom-in">
              Stages of Our Process
            </h2>

            <Card className="custom-card shadow p-2 border-0" style={{ backgroundColor: '#fdfdfd', borderRadius: '20px' }}>
              <Card.Body>
                <p className="text-muted text-center" style={{ fontSize: '1.1rem', lineHeight: '1.8' }}>
                  We provide our work in different stages of the entire process, supporting you through everything from the initial idea to full production.
                </p>

                <div className="d-flex flex-wrap justify-content-center align-items-center gap-3 my-4 process-steps">
                  {steps.map((step, index) => (
                    <div key={index} className="d-flex align-items-center">
                      <div className="step-circle text-center">
                        <div className="step-icon">{step.icon}</div>
                        <small className="step-title">{step.title}</small>
                      </div>
                      {index !== steps.length - 1 && (
                        <FaArrowRight className="mx-2 text-arrow" />
                      )}
                    </div>
                  ))}
                </div>

                <p className="text-muted mt-3" style={{ fontSize: '1.1rem', lineHeight: '1.8' }}>
                  We guide you on how to prepare a quality product as per market demand and how to pack snacks and namkeen. We also provide quality testing managers and staff to assist you. Whether it’s managing bulk orders, maintaining quality consistency, or expanding your team for future growth — we are here to support new businesses like yours. You're most welcome to the Namkeen Contractor family.
                </p>
              </Card.Body>
            </Card>
          </Container>
        </section>




        {/* Manufacturing Process */}


        {/* Working Module */}
        <section className="mb-3">
          <h2 className="middletext mb-4 text-center" data-aos="zoom-in">
            Working Module
          </h2>
          <Container>
            <Row className="justify-content-center">
              <Col md={10}>
                <Card className=" shadow-lg">
                  <Row>
                    {/* Left side - Module titles */}
                    <Col md={4} className="border-end workingleft p-3">
                      <ListGroup variant="flush">
                        {modules.map((mod, index) => (
                          <ListGroup.Item
                            key={index}
                            action
                            onClick={() => setActiveModule(index)}
                            active={index === activeModule}
                            style={{
                              cursor: 'pointer',
                              fontWeight: 'bold',
                              borderRadius: '5px',
                              marginBottom: '5px'
                            }}
                          >
                            {mod.title}

                          </ListGroup.Item>
                        ))}
                      </ListGroup>

                    </Col>

                    {/* Right side - Description */}
                    <Col md={8} className='workingright p-3'>
                      <h4 className="mb-3 text-decoration-underline">{modules[activeModule].title}</h4>
                      <p style={{ textAlign: 'justify', whiteSpace: 'pre-line' }}>
                        {modules[activeModule].description.trim()}
                      </p>
                    </Col>
                  </Row>
                </Card>

                {/* Extra Section Below Modules */}
                <Card className="p-4 shadow mt-3">
                  <h4>Empowering Business with Namkeen Expertise and Seamless Support-</h4>
                  <Card.Body>
                    <p style={{ textAlign: 'justify', whiteSpace: 'pre-line' }}>{extraContent.trim()}</p>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </section>

        {/* Project Finalization & Production Setup */}
        <section className="mb-0 mt-5">
          <h2 className="middletext mb-3 " data-aos="zoom-in">Project Finalization & Production Setup</h2>
          <Row className="justify-content-center">
            <Col lg={8} className="text-center">
              <h4 className="fw-bold">Our Services</h4>
              <h6 className="text-muted">
                As we provide our work in different stages of all process in which we have things like helping with the full procedure from.
              </h6>
            </Col>
          </Row>

          <div style={{ background: '#fdfcfb' }}>
            <Container className="py-3">
              {serviceRows.map((pair, idx) => (
                <Row key={idx} className="mb-1">
                  {pair.map((service, i) => (
                  <Col md={6} key={i} className="mb-3">

                      <div
                        className="p-2  rounded shadow-sm h-100 servicepagecard"
                        style={{
                          backgroundColor: (idx * 2 + i) % 2 === 0 ? '#fff5eb' : '#f9f1ea',
                          borderLeft: '6px solid #DC4321',
                          
                        }}
                      >
                        <div className='text-center'
                          style={{ fontSize: '25px' }}
                        >
                          {service.icon}
                        </div>
                        <h5 className="fw-bold mb-2 
                           prodsertitle text-center">
                          {service.title}
                        </h5>
                        <p className="text-muted mb-0 mx-2">
                          {service.description}
                          </p>
                      </div>
                    </Col>
                  ))}
                </Row>
              ))}
            </Container>
          </div>
        </section>


      </Container>
    </div>
  );
}
